import { useDeliveryApi } from 'infrastructure/api';
import projectNoteValidation from '../timeline/createupdate/projectNoteValidation';

const useRiskNotesService = () => {
  const { sendPostRequest, sendPatchRequest, sendDeleteRequest } = useDeliveryApi();

  const createRiskNote = async (riskId: string, command: { text: string; attachmentPaths?: string[] }) => {
    const response = await sendPostRequest(`/projects/risks/${riskId}/timeline`, {
      text: command.text,
      attachmentPaths: command.attachmentPaths || [],
    });

    return response.json();
  };

  // TODO: change endpoints after backend update
  const updateRiskNote = async (
    projectId: string,
    riskId: string,
    noteId: string,
    command: { text: string; attachmentPaths?: string[] },
  ) => {
    const response = await sendPatchRequest(`/projects/risks/timeline/${noteId}`, {
      text: command.text,
      attachmentPaths: command.attachmentPaths || [],
    });

    return response.json();
  };

  const deleteRiskNote = async (projectId: string, riskId: string, noteId: string) => {
    return await sendDeleteRequest(`/projects/risks/timeline/${noteId}`, {});
  };

  const pinRiskTimeline = async (projectId: string, riskId: string, timelineId: string, pinStatus: boolean) => {
    const response = await sendPatchRequest(`/projects/risks/timeline/${timelineId}/pin`, {
      isPinned: pinStatus,
    });
    return response.json();
  };

  const getNoteValidationSchema = () => Promise.resolve(projectNoteValidation);

  return {
    createRiskNote,
    updateRiskNote,
    deleteRiskNote,
    pinRiskTimeline,
    getNoteValidationSchema,
  };
};

export default useRiskNotesService;
